/**
 *!! Change to `[]` to disable PL maintenance banner.
 *
 * An array containing strings like  dev | stage | prod
 */

const publicLandingSupportedEnvironments = ['prod'];

/**
 * !! Change to `[]` to disable landing maintenance mode
 *
 * US Regions ['us-1', 'trend-us-1', 'gb-1', 'de-1', 'ca-1'];
 * APAC Region ['in-1', 'jp-1', 'sg-1', 'au-1'];
 *
 * When disabling access to C1WS in Staging, use only 'us-1' region
 */
const maintenanceRegions = [];

/** !! Change to `undefined` to disable landing maintenance mode
 *
 *  dev | stage | prod | undefined
 */
const landingMaintenanceEnvironment = undefined;

// Determine whether to show PL maintenace banner
export const configurePublicLandingMaintenanceMode = () => {
  if (
    publicLandingSupportedEnvironments.length > 0 &&
    publicLandingSupportedEnvironments.includes(DEPLOYMENT_TARGET)
  ) {
    window.localStorage.setItem('C1C_Maintenance_Mode', 'true');
  } else {
    window.localStorage.removeItem('C1C_Maintenance_Mode');
  }
};

export function checkLandingMaintenanceMode(currentAccountRegion, serviceId) {
  const serviceInMaintenanceMode =
    serviceId === 'workload' &&
    landingMaintenanceEnvironment !== undefined &&
    DEPLOYMENT_TARGET === landingMaintenanceEnvironment &&
    maintenanceRegions.some((affectedRegion) => affectedRegion === currentAccountRegion);

  if (serviceInMaintenanceMode) {
    localStorage.setItem('Maintenance_Mode', 'true'); // LocalStorage item is cleared after signout
  }

  return serviceInMaintenanceMode;
}
